export default __webpack_public_path__ + "static/media/91t.52a5da7d.jpg";